import { PARAM_FILTER, PLUS_FILTERS } from "@/common/config";

export const toPairs = (initialArray = []) =>
  initialArray.reduce((result, value, index, array) => {
    if (index % 2 === 0) result.push(array.slice(index, index + 2));
    return result;
  }, []);
export const Filter = {
  Resolve: async (ctx) => {
    /*keyword is search string param for aqar filters*/
    const { default: x } = await import("./ssr/map.categories[name].fields");
    const KEYS = { ...x, rent_period: x.rent_period_ };
    const { params, keyword, start, end, ...values } = ctx?.query;
    const keys = Object.keys(values || {}).filter(
      (key) =>
        PLUS_FILTERS[key] ||
        (!PARAM_FILTER[key] && KEYS[key] && values[key]?.includes(",")),
    );
    let has_pg = false;
    const filters = keys.reduce((acc, key) => {
      return {
        ...acc,
        [key]: toPairs(values[key]?.split(",")).reduce(
          (acc2, [operation, value]) => {
            if (!/eq|neq|gt|gte|lt|lte|inar|ninar/.test(operation)) return null;
            if (/sleep|or|and|;|'|"/.test(value?.toLowerCase() || ""))
              has_pg = true;
            return {
              ...acc2,
              [operation]: value?.replace(/=(.+)/g, ""),
            };
          },
          {},
        ),
      };
    }, {});

    try {
      if (has_pg) {
        const ips = [
          ctx.req.ip,
          ctx.req.headers["x-forwarded-for"],
          ctx.req.headers["x-real-ip"],
          ctx.req?.connection?.remoteAddress,
        ];

        console.log(
          "DEBUG_SQL",
          ips.filter(Boolean),
          ctx.req.headers,
          JSON.stringify(filters),
        );
      }
    } catch (e) {}

    if (`${filters?.rent_period?.eq}` === "1") {
      delete filters.rent_period;
    }
    ctx.path = {
      ssr: true,
      hasFilters: !!Object.keys(filters).length,
      filters: {
        keyword,
        ...filters,
        ...(`${filters.unpublished?.eq}` === "1"
          ? { published: { eq: 0 } }
          : {}),
      },
    };

    return ctx.path;
  },
  Daily: {
    Resolve: async (ctx) => {
      const { start, end } = ctx?.query;
      let day_date = { gte: parseFloat(start), lte: parseFloat(end) };
      if (!day_date.gte || !day_date.lte) day_date = undefined;
      ctx.path.filters.published = { eq: 1 };
      ctx.path = {
        basePath: "/الحجز-اليومي",
        homeLabel: "الإيجار اليومي",
        isDaily: true,
        mode: "daily",
        daily_renting_filter: {
          availability: { eq: 1 },
          day_date,
        },
        filters: ctx.path.filters,
      };
      return ctx.path;
    },
  },
  Map: {
    Resolve: (basePath) => (ctx) => {
      ctx.path.basePath = basePath;
    },
  },
};
export default Filter;
